module.exports = __webpack_public_path__ + "static/barcoded-labels-d9d79d0af9d99ccae7510a7018fc3159.png";